import { render, staticRenderFns } from "./AboutErovContent.vue?vue&type=template&id=7de3ae30&scoped=true&lang=html"
import script from "./AboutErovContent.vue?vue&type=script&lang=js"
export * from "./AboutErovContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7de3ae30",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/html/untrrv2/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7de3ae30')) {
      api.createRecord('7de3ae30', component.options)
    } else {
      api.reload('7de3ae30', component.options)
    }
    module.hot.accept("./AboutErovContent.vue?vue&type=template&id=7de3ae30&scoped=true&lang=html", function () {
      api.rerender('7de3ae30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AboutErovContent.vue"
export default component.exports